import { useEffect, useState } from "react";

const FullPageLoader = () => {
  const messages = [
    "Welcome to Blazpay",
    "AI Powered Defi..",
    "Future of Defi",
    "AI Powered Defi..",
  ];

  const [currentMessage, setCurrentMessage] = useState(messages[0]);
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessage(messages[messageIndex]);
      setMessageIndex((prev) => (prev + 1) % messages.length);
    }, 400);

    return () => {
      clearInterval(interval);
    };
  }, [messageIndex, messages]);

  return (
    <section className="w-full fixed bg-black z-999999 top-0 left-0 min-h-screen ">
      <div className="container-loader-f">
        <div className="loader-f"></div>
        <p id="message-1" className="text-white loader">
          {currentMessage}
        </p>
      </div>
    </section>
  );
};

export default FullPageLoader;
